import { CollectionData, PaginationResults } from "@/lib/type";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import { StaffActivityLog } from "./pos.type";

export type StaffLogQuery = {
  staffUsername?: string;
  action?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
};

export const StaffLogApi = createApi({
  reducerPath: "staffLogApi",
  tagTypes: ["staffLog"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getStaffActivityLogs: build.query<
      PaginationResults<StaffActivityLog>,
      { restaurantId: string; query?: StaffLogQuery }
    >({
      query: ({ restaurantId, query }) => ({
        url: `restaurants/${restaurantId}/staff_activity_logs`,
        method: "GET",
        params: query,
      }),
      providesTags: ["staffLog"],
      transformResponse: (data: CollectionData<StaffActivityLog>) => ({
        results: data["hydra:member"],
        count: data["hydra:totalItems"],
      }),
    }),
  }),
});

export const { useGetStaffActivityLogsQuery } = StaffLogApi;
